import { render } from "./PasswordStep.vue?vue&type=template&id=33107882&scoped=true"
import script from "./PasswordStep.vue?vue&type=script&lang=js"
export * from "./PasswordStep.vue?vue&type=script&lang=js"

import "./PasswordStep.vue?vue&type=style&index=0&id=33107882&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33107882"]])

export default __exports__